module.exports = __webpack_public_path__ + "3a7f9756a744aa5449409e90747efcf0.svg";